/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getMenuData } from '../store/slices/menuSlice'
import { getWebsiteData } from '../store/slices/websiteSlice'
// import moment from 'moment'

export const useMenu = (setSlimHeader) => {
  const dispatch = useDispatch()
  const menuData = useSelector((state) => state.menu)
  const websiteData = useSelector((state) => state.website)

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset > 50) setSlimHeader(true)
      else setSlimHeader(false)
    }
    if (menuData.status === 'idle') {
      dispatch(getMenuData())
    }
    if (websiteData.status === 'idle') {
      dispatch(getWebsiteData())
    }
  }, [])

  // useEffect(() => {
  //   const now = moment()
  //   let earlier = menuData.expires_at
  //   let diff_minutes = now.diff(earlier, 'hours')

  //   // Trigger only if expire_in exits and difference greater than n, else use it from localstorage
  //   const PRODUCTION = process.env.REACT_APP_PRODUCTION
  //   let expire_out =
  //     PRODUCTION === 'true'
  //       ? process.env.REACT_APP_CLEAR_LOCAL_STORAGE_LIVE
  //       : process.env.REACT_APP_CLEAR_LOCAL_STORAGE_STAGING

  //   if (menuData.status !=='loading'  && (diff_minutes >= expire_out || menuData.expires_at ===null ||  menuData.menuData===null || isNaN(diff_minutes))) {
  //     dispatch(getMenuData())
  //   }

  //   if (websiteData.status !=='loading'  && (diff_minutes >= expire_out || websiteData.expires_at ===null ||  websiteData.websiteData===null)) {
  //     dispatch(getWebsiteData())
  //   }
  // }, [])

  return { menuData: menuData?.menuData, websiteData: websiteData?.websiteData }
}
